<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" md="12">
        <component-header
          title="Edit Coupon"
          :hasSearch="false"
          :hasCreate="false"
          :hasReload="false"
          :hasback="true"
          @back-press="$router.push({ name: 'Coupon' })"
        />
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col cols="12" md="12">
        <b-card>
          <div v-if="isLoading" class="text-center py-4">Loading coupon details...</div>
          <div v-else-if="loadError" class="text-center py-4 text-danger">
            {{ loadError }}
          </div>
          <ValidationObserver v-else ref="observer" v-slot="{ invalid }">
            <form>
              <b-row>
                <b-col cols="12" sm="12" md="4">
                  <div class="form-group">
                    <label for="promoCode">Coupon Code</label>
                    <ValidationProvider rules="required" v-slot="{ errors }" name="Coupon Code">
                      <b-form-input
                        class="custom-transform-class"
                        id="promoCode"
                        disabled
                        inputType="text"
                        v-model="inputObject.promoCode"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col cols="12" sm="12" md="4">
                  <div class="form-group">
                    <label for="categoryOptions">Applicable On</label>
                    <ValidationProvider rules="required" v-slot="{ errors }" name="Applicable On">
                      <eb-select
                        id="categoryOptions"
                        type="text"
                        label="label"
                        v-model="inputObject.applicableOn"
                        :options="categoryOptions"
                        @input="fetchAllPartnerList"
                        placeholder="Select applicableOn"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col cols="12" sm="12" md="4" v-if="inputObject.applicableOn.value === 'CATALOG'">
                  <div class="form-group">
                    <label for="catalog-id">Catalog</label>
                    <ValidationProvider rules="required" v-slot="{ errors }" name="Catalog">
                      <eb-select
                        id="catalog-id"
                        type="text"
                        label="text"
                        :options="catalogList"
                        v-model="inputObject.catalogId"
                        placeholder="Select Catalog"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col cols="12" sm="12" md="4" v-if="inputObject.applicableOn.value === 'ITEM'">
                  <b-row>
                    <b-col col="12">
                      <div class="form-group">
                        <label for="item-catalog-id">Catalog</label>
                        <ValidationProvider rules="required" v-slot="{ errors }" name="Catalog">
                          <eb-select
                            id="item-catalog-id"
                            type="text"
                            label="text"
                            :options="catalogList"
                            v-model="inputObject.catalogId"
                            placeholder="Select Item catalog"
                            @input="itemCatalogSelected"
                          />
                          <span class="validate-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row v-if="inputObject.catalogId">
                    <b-col col="12">
                      <div class="form-group">
                        <label for="item-id">Item</label>
                        <ValidationProvider rules="required" v-slot="{ errors }" name="Item">
                          <eb-select
                            id="item-id"
                            type="text"
                            label="text"
                            :options="itemsList"
                            v-model="inputObject.itemId"
                            placeholder="Select Item"
                            value="value"
                          />
                          <span class="validate-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="4" v-if="inputObject.applicableOn.value === 'PARTNER' && userRole === 'Tenant'">
                  <div class="form-group">
                    <label for="selectSeller">Partner</label>
                    <ValidationProvider rules="required" v-slot="{ errors }" name="Partner">
                      <eb-select
                        type="text"
                        :id="'selectSeller'"
                        v-model="currentProvider"
                        :options="partnerList"
                        label="name"
                        placeholder="Select Partner"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="12" md="4">
                  <div class="form-group">
                    <label for="title">Title</label>
                    <ValidationProvider rules="required" v-slot="{ errors }" name="Title">
                      <textarea
                        rows="4"
                        cols="30"
                        id="title"
                        class="form-control custom-transform-class"
                        inputType="text"
                        maxlength="300"
                        v-model="inputObject.title"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <label for="description">Description</label>
                    <ValidationProvider rules="required" v-slot="{ errors }" name="description">
                      <textarea
                        rows="4"
                        cols="30"
                        class="form-control"
                        id="description"
                        inputType="text"
                        maxlength="1500"
                        v-model="inputObject.description"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <div class="form-group">
                    <label for="startdate">Start Date</label>
                    <ValidationProvider rules="required|futureDate" v-slot="{ errors }" name="Start Date">
                      <b-input id="startdate" type="date" v-model="inputObject.startDate" />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <label for="enddate">End Date</label>
                    <ValidationProvider rules="required|afterDate:startDate" v-slot="{ errors }" name="End Date">
                      <b-input id="enddate" type="date" v-model="inputObject.endDate" />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <label for="maxRewardValue">Max Reward Value</label>
                    <ValidationProvider rules="required" v-slot="{ errors }" name="Max Reward Value">
                      <b-form-input id="maxRewardValue" inputType="text" maxlength="100" v-model="inputObject.maxRewardValue" />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <div class="form-group">
                    <label for="minimumAmountExcludingTax">Minimum Amount Excluding Tax</label>
                    <ValidationProvider rules="required" v-slot="{ errors }" name="Minimum Amount Excluding Tax">
                      <b-form-input id="minimumAmountExcludingTax" inputType="text" maxlength="100" v-model="inputObject.minimumAmountExcludingTax" />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <label for="rewardValue" v-if="inputObject.discountType.value === 'Percentage'">Reward Percentage</label>
                    <label for="rewardValue" v-else>Reward Value</label>
                    <ValidationProvider rules="required" v-slot="{ errors }" name="Reward Value">
                      <b-input id="rewardValue" type="text" v-model="inputObject.rewardValue" />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <label for="within">Frequency in minutes</label>
                    <ValidationProvider rules="required" v-slot="{ errors }" name="Timing Rules">
                      <b-form-input id="within" inputType="text" v-model="timingRules.within" />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
              </b-row>
              <div>
                <b-row>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="discountType">Discount Type</label>
                      <ValidationProvider rules="required" v-slot="{ errors }" name="Discount Type">
                        <eb-select id="discountType" type="text" label="label" v-model="inputObject.discountType" :options="discountType" placeholder="Select discount type" />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="rewardType">Reward Type</label>
                      <eb-select id="rewardType" type="text" label="label" v-model="inputObject.rewardType" :options="rewardType" placeholder="Select reward type" />
                    </div>
                  </b-col>
                  <b-col md="4" v-if="inputObject.rewardType.value === 'Wallet'">
                    <div class="form-group">
                      <label for="rewardBalanceType">Reward Balance Type</label>
                      <eb-select id="rewardBalanceType" type="text" label="name" v-model="inputObject.rewardBalanceType" :options="rewardBalanceType" placeholder="Select reward Balance type" />
                    </div>
                  </b-col>
                </b-row>
                <b-row v-if="inputObject.rewardType.value === 'Wallet'">
                  <b-col md="4">
                    <div class="form-group">
                      <label for="expiryValue">Enter Expiry</label>
                      <ValidationProvider rules="required" v-slot="{ errors }" name="Expiry">
                        <b-form-input class="custom-transform-class" id="expiryValue" inputType="number" placeholder="Enter Expiry Value" v-model="inputObject.value" />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="uom">UOM</label>
                      <eb-select type="text" v-model="inputObject.uom" :options="['Days', 'Months', 'Years']" id="uom" placeholder="UOM" />
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="totalLimit">Total allowed in day</label>
                      <ValidationProvider rules="required" v-slot="{ errors }" name="Timing Rules">
                        <b-form-input id="totalLimit" inputType="text" v-model="timingRules.totalLimit" />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="maxExisting">Max Existing Orders</label>
                      <b-form-input id="maxExisting" inputType="text" v-model="inputObject.maxExistingOrders" />
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="minExiting">Min Existing Orders</label>
                      <b-form-input id="minExiting" inputType="text" v-model="inputObject.minExistingOrders" />
                    </div>
                  </b-col>
                  <b-col md="12">
                    <b-row>
                      <b-col md="4">
                        <div class="form-group">
                          <label for="maximumQuantity">Maximum Quantity</label>
                          <b-form-input id="maximumQuantity" inputType="text" v-model="inputObject.maxQuantity" />
                        </div>
                      </b-col>
                      <b-col md="4">
                        <div class="form-group">
                          <label for="minimumQuantity">Minimum Quantity</label>
                          <b-form-input id="minimumQuantity" inputType="text" v-model="inputObject.minQuantity" />
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="12">
                    <b-row>
                      <b-col md="4">
                        <div class="form-group">
                          <b-form-checkbox switch v-model="showOption">Location Rule</b-form-checkbox>
                        </div>
                      </b-col>
                      <b-col md="4" v-if="showOption === true">
                        <div class="form-group">
                          <label>Location</label>
                          <ValidationProvider rules="required" v-slot="{ errors }" name="Location label">
                            <eb-select id="locationSelect" type="text" :options="['City', 'State']" placeholder="Select Location Label" v-model="inputObject.locationSelected" />
                            <span class="validate-error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </b-col>
                      <b-col md="4" v-if="showOption === true">
                        <div class="form-group">
                          <label>Location Value</label>
                          <ValidationProvider rules="required" v-slot="{ errors }" name="Location Value">
                            <b-form-input inputType="text" id="locationValue" v-model="inputObject.locationValue" />
                            <span class="validate-error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col cols="12" sm="12" md="4" v-for="(terms, idx) in tc" :key="idx">
                  <div class="form-group">
                    <label for="tc">Terms and Conditions</label>
                    <ValidationProvider rules="required" v-slot="{ errors }" name="Terms and Conditions">
                      <textarea id="tc" rows="4" cols="30" class="form-control" inputType="text" maxlength="3000" v-model="terms.tc" />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="12" md="4">
                  <div class="form-group">
                    <b-form-checkbox switch v-model="allowMultiDiscount">Allow MultiDiscount</b-form-checkbox>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <b-form-checkbox switch v-model="promote">Promote</b-form-checkbox>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <b-form-checkbox switch v-model="autoApply">AutoApply</b-form-checkbox>
                  </div>
                </b-col>
              </b-row>
              <hr />
              <div class="text-center mt-3 mb-3">
                <button type="button" class="btn btn-primary wide-button" :disabled="invalid || submitting" @click.prevent="handleSubmit">
                  {{ submitting ? "Updating..." : "Update" }}
                </button>
              </div>
            </form>
          </ValidationObserver>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, Validator } from "vee-validate/dist/vee-validate.esm";
import ebSelect from "@/components/FormElements/Select.vue";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";

const APPLICABLE_ON = {
  CATALOG: "CATALOG",
  PARTNER: "PARTNER",
  ITEM: "ITEM",
  ORDER: "ORDER",
  REGISTRATION: "REGISTRATION",
  REFERRAL: "REFERRAL",
};

const LOCATION_TYPE = {
  CITY: "city",
  STATE: "state",
};

const REWARD_TYPE = {
  DISCOUNT: "Discount",
  SHIPPING: "Shipping",
  WALLET: "Wallet",
};

const USER_ROLE = {
  TENANT: "Tenant",
  SELLER: "SELLER",
};

export default {
  name: "EditCoupon",
  components: { ValidationProvider, ValidationObserver, ebSelect, ComponentHeader },
  data() {
    return {
      isLoading: true,
      loadError: "",
      submitting: false,
      couponId: "",
      showOption: false,
      currentProvider: null,
      allowMultiDiscount: false,
      promote: false,
      autoApply: false,
      timingRules: { within: "", totalLimit: "" },
      inputObject: {
        rewardType: "",
        rewardBalanceType: "",
        uom: "",
        value: 0,
        title: "",
        description: "",
        catalogId: "",
        maxRewardValue: "",
        minimumAmountExcludingTax: "",
        applicableOn: "",
        discountType: "",
        itemId: "",
        tags: [],
        startDate: "",
        endDate: "",
        promoCode: "",
        rewardValue: "",
        maxExistingOrders: null,
        minExistingOrders: null,
        minQuantity: null,
        maxQuantity: null,
        locationValue: "",
        locationSelected: "",
      },
      tc: [{ tc: "", isRemovable: false, text: "Add" }],
      catalogList: [],
      rewardType: [
        { label: REWARD_TYPE.DISCOUNT, value: REWARD_TYPE.DISCOUNT },
        { label: REWARD_TYPE.SHIPPING, value: REWARD_TYPE.SHIPPING },
        { label: REWARD_TYPE.WALLET, value: REWARD_TYPE.WALLET },
      ],
      discountType: [
        { label: "Number", value: "Number" },
        { label: "Percentage", value: "Percentage" },
      ],
      itemsList: [],
    };
  },
  computed: {
    ...mapGetters({ provider: "auth/getUserID" }),
    rewardBalanceType() {
      return this.transformStoreData(this.$store.getters["partner/GetWalletData"], (obj) => ({
        _id: obj.resourceID,
        name: obj.code,
      }));
    },
    categoryOptions() {
      const isNotSeller = this.$currentUserData?.category !== USER_ROLE.SELLER;
      const baseOptions = [
        { label: "Catalog", value: APPLICABLE_ON.CATALOG },
        { label: "Item", value: APPLICABLE_ON.ITEM },
        { label: "Order", value: APPLICABLE_ON.ORDER },
      ];
      const additionalOptions = [
        { label: "Partner", value: APPLICABLE_ON.PARTNER },
        { label: "Registration", value: APPLICABLE_ON.REGISTRATION },
        { label: "Referral", value: APPLICABLE_ON.REFERRAL },
      ];
      return isNotSeller ? [...baseOptions.slice(0, 1), ...additionalOptions, ...baseOptions.slice(1)] : baseOptions;
    },
    partnerList() {
      return this.transformStoreData(this.$store.getters["partner/GetPartnerLiteList"], (obj) => ({
        _id: obj._id,
        name: obj.organization.name,
        ...obj,
      }));
    },
    userRole() {
      return this.$store.getters["auth/getUserRole"] || JSON.parse(sessionStorage.getItem("userLogin"))?.role;
    },
    isTenant() {
      return this.userRole === USER_ROLE.TENANT;
    },
  },
  async mounted() {
    await this.initializeComponent();
  },
  methods: {
    ...mapActions({
      Getpartnerlist: "partner/fetchPartnerListLite",
      GetWalletList: "partner/fetchWalletList",
    }),
    async initializeComponent() {
      this.loadError = "";
      this.isLoading = true;
      try {
        this.setupValidators();
        await Promise.all([this.Getpartnerlist({ type: "" }), this.getCatalogName(), this.GetWalletList()]);
        const details = await this.resolveCouponData();
        this.prefillForm(details);
      } catch (error) {
        this.loadError = error?.message || "Failed to load coupon details.";
      } finally {
        this.isLoading = false;
      }
    },
    setupValidators() {
      Validator.extend("afterDate", (value) => moment(value).diff(this.inputObject.startDate, "hour") >= 0, { hasTarget: true });
      Validator.extend("futureDate", (value) => moment().diff(this.inputObject.startDate, "day") <= 0, { hasTarget: true });
    },
    transformStoreData(data, transformer) {
      if (!Array.isArray(data) || data.length === 0) return [];
      return data.map(transformer);
    },
    async resolveCouponData() {
      const routeData = this.$route.params?.data;
      const routeId = this.$route.params?.id || this.$route.query?.id;
      if (routeData && routeData._id) {
        this.couponId = routeData._id;
        return routeData;
      }
      if (!routeId) {
        throw new Error("Coupon data not found. Please open this page from coupon list.");
      }
      const coupons = await this.$store.dispatch("coupon/couponCodeList", this.userRole);
      const matched = (Array.isArray(coupons) ? coupons : []).find((coupon) => coupon._id === routeId);
      if (!matched) throw new Error("Invalid coupon ID. Coupon not found.");
      this.couponId = matched._id;
      return matched;
    },
    normalizeDate(dateValue) {
      return dateValue ? String(dateValue).slice(0, 10) : "";
    },
    getOptionByValue(options, value, labelKey = "label", valueKey = "value") {
      return options.find((option) => option[valueKey] === value) || { [labelKey]: value, [valueKey]: value };
    },
    async prefillForm(details) {
      const promoRules = details?.promoRules || {};
      this.couponId = this.couponId || details?._id || "";
      this.inputObject.promoCode = details?.promoCode || "";
      this.inputObject.title = details?.title || "";
      this.inputObject.description = details?.description || "";
      this.inputObject.applicableOn = this.getOptionByValue(this.categoryOptions, promoRules.applicableOn || "");
      this.inputObject.discountType = this.getOptionByValue(this.discountType, promoRules.discountType || "");
      this.inputObject.rewardType = this.getOptionByValue(this.rewardType, promoRules.rewardType || REWARD_TYPE.DISCOUNT);
      this.inputObject.catalogId = this.getOptionByValue(this.catalogList, promoRules.catalogId || "", "text", "value");
      this.inputObject.startDate = this.normalizeDate(promoRules.startDate);
      this.inputObject.endDate = this.normalizeDate(promoRules.endDate);
      this.inputObject.maxRewardValue = promoRules.maxRewardValue != null ? promoRules.maxRewardValue : "";
      this.inputObject.minimumAmountExcludingTax = promoRules.minimumAmountExcludingTax != null ? promoRules.minimumAmountExcludingTax : "";
      this.inputObject.rewardValue = promoRules.rewardValue != null ? promoRules.rewardValue : "";
      this.inputObject.maxExistingOrders = promoRules.maxExistingOrders != null ? promoRules.maxExistingOrders : null;
      this.inputObject.minExistingOrders = promoRules.minExistingOrders != null ? promoRules.minExistingOrders : null;
      this.inputObject.minQuantity = promoRules.minQuantity != null ? promoRules.minQuantity : null;
      this.inputObject.maxQuantity = promoRules.maxQuantity != null ? promoRules.maxQuantity : null;
      this.timingRules.within = details && details.timingRules && details.timingRules.within != null ? details.timingRules.within : "";
      this.timingRules.totalLimit = details && details.timingRules && details.timingRules.totalLimit != null ? details.timingRules.totalLimit : "";
      this.allowMultiDiscount = !!details?.allowMultiDiscount;
      this.promote = !!details?.promote;
      this.autoApply = !!details?.autoApply;
      this.inputObject.tags = Array.isArray(details?.tags) ? details.tags : [];
      this.tc = Array.isArray(details?.tc) && details.tc.length ? details.tc.map((t, i) => ({ tc: t, isRemovable: i !== 0, text: i !== 0 ? "Remove" : "Add" })) : [{ tc: "", isRemovable: false, text: "Add" }];
      if (promoRules.applicableOn === APPLICABLE_ON.PARTNER && promoRules.providerId) {
        this.currentProvider = this.partnerList.find((partner) => partner._id === promoRules.providerId) || null;
      }
      if (promoRules.applicableOn === APPLICABLE_ON.ITEM && promoRules.catalogId) {
        await this.itemCatalogSelected(this.inputObject.catalogId);
        this.inputObject.itemId = this.getOptionByValue(this.itemsList, promoRules.itemId || "", "text", "value");
      } else if (promoRules.itemId) {
        this.inputObject.itemId = { text: promoRules.itemId, value: promoRules.itemId };
      }
      if (promoRules.wallet) {
        this.inputObject.rewardBalanceType = this.rewardBalanceType.find((w) => w._id === promoRules.wallet?.amountType?.key) || "";
        this.inputObject.value = promoRules.wallet?.expireIn?.value || 0;
        this.inputObject.uom = promoRules.wallet?.expireIn?.uom || "";
      }
      if (details?.locationRules?.city) {
        this.showOption = true;
        this.inputObject.locationSelected = "City";
        this.inputObject.locationValue = details.locationRules.city;
      } else if (details?.locationRules?.state) {
        this.showOption = true;
        this.inputObject.locationSelected = "State";
        this.inputObject.locationValue = details.locationRules.state;
      }
    },
    fetchAllPartnerList() {
      const shouldFetchPartners = this.inputObject.applicableOn.value === APPLICABLE_ON.PARTNER && this.isTenant && (!Array.isArray(this.partnerList) || this.partnerList.length === 0);
      if (shouldFetchPartners) {
        this.Getpartnerlist({ type: "" });
      }
    },
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid || !this.couponId) return;
      this.submitting = true;
      try {
        const couponData = this.buildCouponData();
        await this.$store.dispatch("coupon/editCouponcode", couponData);
        await this.refreshCouponList();
        this.$swal({ title: "Success", text: "Coupon updated successfully!!", type: "success" });
        this.$router.push({ name: "Coupon" });
      } catch (error) {
        this.$toasted.error(error?.message || "Failed to update coupon");
      } finally {
        this.submitting = false;
      }
    },
    buildCouponData() {
      const data = {
        promoCode: this.inputObject.promoCode.toUpperCase(),
        description: this.inputObject.description,
        title: this.inputObject.title.toUpperCase(),
        promoRules: this.buildPromoRules(),
        timingRules: { within: this.timingRules.within, totalLimit: this.timingRules.totalLimit },
        tc: this.tc.map((t) => t.tc),
        tags: this.inputObject.tags,
        autoApply: this.autoApply,
        allowMultiDiscount: this.allowMultiDiscount,
        promote: this.promote,
      };
      this.addWalletRules(data);
      this.addLocationRules(data);
      this.addApplicableRules(data);
      return data;
    },
    buildPromoRules() {
      return {
        startDate: this.inputObject.startDate,
        endDate: this.inputObject.endDate,
        maxRewardValue: this.inputObject.maxRewardValue,
        minimumAmountExcludingTax: this.inputObject.minimumAmountExcludingTax,
        rewardValue: this.inputObject.rewardValue,
        discountType: this.inputObject.discountType?.value || this.inputObject.discountType,
        rewardType: this.inputObject.rewardType?.value || this.inputObject.rewardType,
        applicableOn: this.inputObject.applicableOn?.value || this.inputObject.applicableOn,
        maxExistingOrders: this.inputObject.maxExistingOrders,
        minExistingOrders: this.inputObject.minExistingOrders,
        minQuantity: this.inputObject.minQuantity,
        maxQuantity: this.inputObject.maxQuantity,
      };
    },
    addWalletRules(data) {
      if (this.inputObject.rewardType.value === REWARD_TYPE.WALLET) {
        data.promoRules.wallet = {
          amountType: { key: this.inputObject.rewardBalanceType._id, value: this.inputObject.rewardBalanceType.name },
          expireIn: { value: +this.inputObject.value, uom: this.inputObject.uom },
        };
      }
    },
    addLocationRules(data) {
      const locationTypeLower = (this.inputObject.locationSelected || "").toLowerCase();
      if (locationTypeLower === LOCATION_TYPE.CITY) {
        data.locationRules = { city: (this.inputObject.locationValue || "").toLowerCase() };
      } else if (locationTypeLower === LOCATION_TYPE.STATE) {
        data.locationRules = { state: (this.inputObject.locationValue || "").toLowerCase() };
      }
    },
    addApplicableRules(data) {
      const applicableOn = this.inputObject.applicableOn.value || this.inputObject.applicableOn;
      switch (applicableOn) {
        case APPLICABLE_ON.ITEM:
          data.promoRules.itemId = this.inputObject.itemId?.value || this.inputObject.itemId;
          data.promoRules.catalogId = this.inputObject.catalogId?.value || this.inputObject.catalogId;
          break;
        case APPLICABLE_ON.CATALOG:
          data.promoRules.catalogId = this.inputObject.catalogId?.value || this.inputObject.catalogId;
          break;
        case APPLICABLE_ON.PARTNER:
          if (this.isTenant) data.promoRules.providerId = this.currentProvider?._id || null;
          break;
      }
    },
    async refreshCouponList() {
      await this.$store.dispatch("coupon/couponCodeList", this.$store.getters["auth/getUserID"]);
    },
    async getCatalogName() {
      const catalogConfig = this.isTenant
        ? { action: "catalog/fetchTenantCatalogTree", getter: "catalog/GetTenantCatalogTree", filter: (obj) => !obj.isProductType && !obj.isMarket }
        : { action: "catalog/fetchPartnerCatalogTree", getter: "catalog/GetPartnerCatalogTree", filter: (obj) => obj.isProductType && !obj.isMarket };
      await this.$store.dispatch(catalogConfig.action);
      const result = this.$store.getters[catalogConfig.getter];
      this.catalogList = result.filter(catalogConfig.filter).map((c) => ({ text: c.name, value: c._id })).reverse();
    },
    async itemCatalogSelected(catalogId) {
      this.itemsList = [];
      this.inputObject.catalogId = catalogId;
      let condition = `parent=${catalogId.value}`;
      if (!this.isTenant) {
        condition += `&provider=${this.$store.getters["auth/getUserID"]}`;
      }
      try {
        const { listCatalog } = require("@/services/catalog.js");
        const data = await listCatalog(condition);
        if (data && data.data && data.data.response) {
          const items = Array.isArray(data.data.response) ? data.data.response : [];
          this.itemsList = items.map((item) => ({ text: item.name, value: item._id }));
        }
      } catch (err) {
        console.error("Failed to fetch catalog items", err);
      }
    },
  },
};
</script>
<style scoped>
.custom-transform-class {
  text-transform: uppercase;
}

.help-icon {
  color: #727cf5;
}

.wide-button {
  width: 100px;
  height: 35px;
}
</style>
